/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ConvertToScriptRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {ConvertToScriptResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const convertToScript = (request: ConvertToScriptRequest, options?: CashRequestOptions) => post<ConvertToScriptRequest, ConvertToScriptResponse>("/2.0/cash/convert-to-script", request, {...options, rejectOnError: true })